import { Navigate } from "react-router-dom";
import useUser from "../hooks/useUser";

export default function ProtectedRoute(props: any) {
  const { exists } = useUser();

  return exists ? props.children : <Navigate replace to="/login" />;
}
